import { render, staticRenderFns } from "./CopyButtonAction.vue?vue&type=template&id=0042e89e&"
import script from "./CopyButtonAction.vue?vue&type=script&lang=ts&"
export * from "./CopyButtonAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports